import { Layout } from "./components/Layout";
import { useHash } from "./components/ui";
import { useStore } from "./store";
import { Dashboard } from "./pages/Dashboard";
import { Timeline } from "./pages/Timeline";
import { Characters } from "./pages/Characters";
import { Relations } from "./pages/Relations";
import { Arcs, World } from "./pages/World";
import { Secrets } from "./pages/Secrets";
import { ContinuityPage } from "./pages/Continuity";
import { Writing } from "./pages/Writing";
import { SourcesPage } from "./pages/Sources";
import { Settings } from "./pages/Settings";

export function App() {
  const { bible, syncState, error } = useStore();
  const [hash] = useHash();
  const path = hash.split("?")[0];

  if (!bible) {
    return (
      <div className="page">
        <h1>Bible narrative</h1>
        <p>{syncState === "loading" ? "Chargement de l’archive…" : error ?? "Initialisation."}</p>
      </div>
    );
  }

  let page = <Dashboard />;
  if (path.startsWith("/personnages")) {
    const id = path.split("/")[2];
    page = <Characters characterId={id} />;
  } else if (path.startsWith("/chronologie")) page = <Timeline />;
  else if (path.startsWith("/relations")) page = <Relations />;
  else if (path.startsWith("/monde")) page = <World />;
  else if (path.startsWith("/arcs")) page = <Arcs />;
  else if (path.startsWith("/secrets")) page = <Secrets />;
  else if (path.startsWith("/continuite")) page = <ContinuityPage />;
  else if (path.startsWith("/contexte")) page = <Writing />;
  else if (path.startsWith("/sources")) page = <SourcesPage />;
  else if (path.startsWith("/parametres")) page = <Settings />;

  return <Layout bible={bible}>{page}</Layout>;
}
